/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { HttpParams } from '@angular/common/http';
import { Component, ElementRef, inject, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Post } from '@src/app/model/post';
import { PostService } from '@src/app/modules/social/post/post.service';
import { PostPageNavRoute } from '@src/app/routes/app-router';
import { ChosenWidget, IWidget } from '@src/app/shared/dashboard/DashboardTypes';

@Component({
    selector: 'app-posts-widget',
    imports: [RouterLink],
    templateUrl: './posts-widget.component.html',
    styleUrls: ['../../../../shared/dashboard/hello-world-widget/widget.component.scss']
})
export class PostsWidgetComponent  implements IWidget, OnInit {
  title = $localize `Recent Posts`;
  host: ElementRef<Element> = inject(ElementRef);
  options: { name: string; action: () => void; }[];
  @Input() chosenWidget: ChosenWidget;

  postService = inject(PostService)
  maxItems = 5;
  routerLink = PostPageNavRoute.getListRouterLink();

  data: Post[] = []; 

  ngOnInit(): void {
    const parms = new HttpParams().set('_limitTo', this.maxItems).set('_sortDesc', 'updatedAt');
    this.postService.get<Post>(false, parms).subscribe( data => {
      this.data = data;
    })
  }

  getNavRoute(p: Post) {
    return [PostPageNavRoute.getIdUrl(p.id, p.teamId)];
  }
}
